// extracted by mini-css-extract-plugin
module.exports = {"bannerCarousel":"banner-carousel_bannerCarousel__9WRZ_","viewport":"banner-carousel_viewport__vrgp1","slides":"banner-carousel_slides__38ysI"};